/* eslint-disable */
import gql from "graphql-tag";
import { accountErrorFragment } from "@saleor/fragments/errors";
import makeMutation from "@saleor/hooks/makeMutation";
import {
  UpdateProductActivationSetting,
  UpdateProductActivationSettingVariables
} from "./types/UpdateProductActivationSetting";
import {
  ProductActivationSettingVoucherUpdate,
  ProductActivationSettingVoucherUpdateVariables
} from "./types/ProductActivationSettingVoucherUpdate";

import { ProductActivationSettingCreateDefault } from "@saleor/productActivationSetting/types/ProductActivationSettingCreateDefault";
import { productActivationSettingFragment } from "@saleor/fragments/productactivationsetting";

const updateProductActivationSetting = gql`
  ${accountErrorFragment}
  ${productActivationSettingFragment}
  mutation UpdateProductActivationSetting(
    $id: ID!
    $input: ProductActivationSettingInput!
  ) {
    productActivationSettingUpdate(id: $id, input: $input) {
      productActivationSetting {
        ...ProductActivationSettingFragment
      }
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;
export const useUpdateProductActivationSettingMutation = makeMutation<
  UpdateProductActivationSetting,
  UpdateProductActivationSettingVariables
>(updateProductActivationSetting);

const productActivationSettingVoucherUpdate = gql`
  ${accountErrorFragment}
  ${productActivationSettingFragment}
  mutation ProductActivationSettingVoucherUpdate(
    $id: ID!
    $voucherId: ID
    $voucherType: String!
  ) {
    productActivationSettingVoucherUpdate(
      id: $id
      voucherId: $voucherId
      voucherType: $voucherType
    ) {
      productActivationSetting {
        ...ProductActivationSettingFragment
      }
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;

export const useProductActivationSettingVoucherUpdateMutation = makeMutation<
  ProductActivationSettingVoucherUpdate,
  ProductActivationSettingVoucherUpdateVariables
>(productActivationSettingVoucherUpdate);

const productActivationSettingCreateDefault = gql`
  ${productActivationSettingFragment}
  mutation ProductActivationSettingCreateDefault {
    productActivationSettingCreateDefault {
      productActivationSetting {
        ...ProductActivationSettingFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useProductActivationSettingCreateDefaultMutation = makeMutation<
  ProductActivationSettingCreateDefault,
  null
>(productActivationSettingCreateDefault);
